import type { App } from 'vue';
import type { ArcoIconOptions } from '../../_utils/types';
import _IconDefaultAvatarPrismLightColor from './icon-default-avatar-prism-light-color.vue';

const IconDefaultAvatarPrismLightColor = Object.assign(_IconDefaultAvatarPrismLightColor, {
  install: (app: App, options?: ArcoIconOptions) => {
    const iconPrefix = options?.iconPrefix ?? '';
    app.component(iconPrefix + _IconDefaultAvatarPrismLightColor.name, _IconDefaultAvatarPrismLightColor);
  }
});

export default IconDefaultAvatarPrismLightColor;
